var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotemButton',{attrs:{"size":_vm.size,"color":_vm.color,"label":_vm.label},on:{"click":function($event){return _vm.goToLandingPage(_vm.url)}}})}
var staticRenderFns = []

export { render, staticRenderFns }